import React from 'react';
import { useAppStateContext } from 'src/appState/AppState';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import {
    RaceResultsRowWrapper,
    RaceResultsWrapper,
    ResultsTableMessage,
} from 'src/domains/sportsbook/webview/components/raceCard/raceResults/horseRacing/RaceResultsHr.style';
import { DividendsInfo } from 'src/domains/sportsbook/webview/components/raceCard/raceResults/DividendsInfo';
import { getTopSelectionsSorted } from 'src/domains/sportsbook/webview/components/raceCard/raceResults/utils/Utils';
import { TableHeaderCell } from 'src/ui/components/table/sports/row/hr-gr/event/custom/TableHeaderCell';
import { RaceSummaryCaption } from 'src/domains/sportsbook/webview/components/raceCard/raceResults/greyhoundRacing/RaceResultsGh.style';
import { RaceResultsRow } from 'src/domains/sportsbook/webview/components/raceCard/raceResults/greyhoundRacing/RaceResultsRow';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface RaceResultsGhPropsType {
    race: EventModel;
}

export const RaceResultsGh = observer('RaceResultsGh', (props: RaceResultsGhPropsType) => {
    const { race } = props;
    const { appSportsBookState } = useAppStateContext();
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;
    const { models } = appSportsBookState;

    const topSelectionsSorted = getTopSelectionsSorted(race, models, 'greyhoundracing');
    if (topSelectionsSorted === null) {
        return null;
    }

    return (
        <>
            <ResultsTableMessage>
                <I18n
                    langKey='events.race-results.label'
                    defaultText='Race Results'
                />
            </ResultsTableMessage>
            <RaceResultsWrapper variant={configState.componentVariants.sportsbookVariant}>
                <RaceSummaryCaption variant={configState.componentVariants.sportsbookVariant}>
                    <TableHeaderCell
                        mobileSize='64px'
                        align='center'
                    >
                        <I18n
                            langKey='events.race-results.result.label'
                            defaultText='Result'
                        />
                    </TableHeaderCell>

                    <TableHeaderCell isWide={true}>
                        <I18n
                            langKey='events.race-results.runner.label'
                            defaultText='Runner'
                        />
                    </TableHeaderCell>

                    <TableHeaderCell
                        align='center'
                        mobileSize='48px'
                        tabletSize='63px'
                    >
                        <I18n
                            langKey='events.race-results.selection.sp'
                            defaultText='SP'
                        />
                    </TableHeaderCell>
                </RaceSummaryCaption>
                <RaceResultsRowWrapper variant={configState.componentVariants.sportsbookVariant}>
                    {topSelectionsSorted.map((selection) => {
                        return (
                            <RaceResultsRow
                                key={selection.id2.key}
                                selectionId={selection.id2}
                            />
                        );
                    })}
                </RaceResultsRowWrapper>
                <DividendsInfo
                    models={models}
                    race={race}
                />
            </RaceResultsWrapper>
        </>
    );
});
